export const HST_NUMBER = '731912671RT0001';
export const TAX_RATIO = 0;
export const DEV_ONLY = process.env.REACT_APP_SHOW_DEV_FEATURES === 'true'
export const MAX_HEIGHT_MEDIA_CALC_MOBILE = 'calc(100vw * 1080 / 1920)'
export const MAX_HEIGHT_MEDIA_CALC_DESKTOP = 'calc((100vw * 0.65 - 3em) * 1080 / 1920)'
export const wordPressUrl = process.env.REACT_APP_WORDPRESS_BASEURL || 'https://obsidi.com/bfutr'
export const awsURL = process.env.REACT_APP_AWS_BUCKET_NAME as string
export const PHONE_NUMBER_PLACEHOLDER = '6473333333';